"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsController", {
    enumerable: true,
    get: function() {
        return JobsController;
    }
});
const _common = require("@nestjs/common");
const _eventemitter = require("@nestjs/event-emitter");
const _nanoid = require("nanoid");
const _Jobs = require("~/interface/Jobs");
const _globalguard = require("~/guards/global/global.guard");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _jobsredis = require("~/modules/jobs/redis/jobs-redis");
const _config = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
const POLLING_INTERVAL = 30000;
let JobsController = class JobsController {
    onModuleDestroy() {
        Object.keys(this.jobRooms).forEach((jobId)=>{
            const room = this.jobRooms[jobId];
            room.listeners.forEach((res)=>{
                if (!res.headersSent) {
                    res.send({
                        status: 'refresh'
                    });
                }
            });
        });
    }
    async listen(res, req, body) {
        const { _mid = 0, data } = body;
        const jobId = data.id;
        res.setHeader('Cache-Control', 'no-cache, must-revalidate');
        res.resId = nanoidv2();
        let messages;
        if (this.localJobs[jobId]) {
            messages = this.localJobs[jobId].messages;
        } else {
            var _this;
            messages = (_this = await _NocoCache.default.get('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`, _globals.CacheGetType.TYPE_OBJECT)) == null ? void 0 : _this.messages;
        }
        const newMessages = [];
        if (messages) {
            messages.forEach((m)=>{
                if (m._mid > _mid) {
                    newMessages.push(m);
                }
            });
        }
        if (newMessages.length > 0) {
            res.send(newMessages);
            return;
        }
        if (this.closedJobs.includes(jobId)) {
            res.send({
                status: 'close'
            });
            return;
        }
        if (this.jobRooms[jobId]) {
            this.jobRooms[jobId].listeners.push(res);
        } else {
            this.jobRooms[jobId] = {
                listeners: [
                    res
                ]
            };
            // subscribe to job events
            if (_jobsredis.JobsRedis.available) {
                const unsubscribeCallback = await _jobsredis.JobsRedis.subscribe(jobId, async (data)=>{
                    if (this.jobRooms[jobId]) {
                        this.jobRooms[jobId].listeners.forEach((res)=>{
                            if (!res.headersSent) {
                                res.send({
                                    status: 'refresh'
                                });
                            }
                        });
                    }
                    const cmd = data.cmd;
                    delete data.cmd;
                    switch(cmd){
                        case _Jobs.JobEvents.STATUS:
                            if ([
                                _Jobs.JobStatus.COMPLETED,
                                _Jobs.JobStatus.FAILED
                            ].includes(data.status)) {
                                await unsubscribeCallback();
                                delete this.jobRooms[jobId];
                                // close the job after 1 second (to allow the update of messages)
                                setTimeout(()=>{
                                    this.closedJobs.push(jobId);
                                }, 1000).unref();
                                // remove the job after polling interval * 2
                                setTimeout(()=>{
                                    this.closedJobs = this.closedJobs.filter((j)=>j !== jobId);
                                }, POLLING_INTERVAL * 2).unref();
                            }
                            break;
                    }
                });
            }
        }
        res.on('close', ()=>{
            var _this_jobRooms_jobId;
            if (jobId && ((_this_jobRooms_jobId = this.jobRooms[jobId]) == null ? void 0 : _this_jobRooms_jobId.listeners)) {
                this.jobRooms[jobId].listeners = this.jobRooms[jobId].listeners.filter((r)=>r.resId !== res.resId);
            }
        });
        setTimeout(()=>{
            if (!res.headersSent) {
                res.send({
                    status: 'refresh'
                });
            }
        }, POLLING_INTERVAL).unref();
    }
    async sendJobStatus(data) {
        let response;
        const jobId = data.id;
        // clean as it might be taken by another worker
        if (data.status === _Jobs.JobStatus.REQUEUED) {
            if (this.jobRooms[jobId]) {
                this.jobRooms[jobId].listeners.forEach((res)=>{
                    if (!res.headersSent) {
                        res.send({
                            status: 'refresh'
                        });
                    }
                });
            }
            delete this.jobRooms[jobId];
            delete this.localJobs[jobId];
            await _NocoCache.default.del('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`);
            return;
        }
        if (this.localJobs[jobId]) {
            response = {
                status: 'update',
                data,
                _mid: ++this.localJobs[jobId]._mid
            };
            this.localJobs[jobId].messages.push(response);
            // limit to 20 messages
            if (this.localJobs[jobId].messages.length > 20) {
                this.localJobs[jobId].messages.shift();
            }
            await _NocoCache.default.set('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`, {
                messages: this.localJobs[jobId].messages
            });
        } else {
            response = {
                status: 'update',
                data,
                _mid: 1
            };
            this.localJobs[jobId] = {
                messages: [
                    response
                ],
                _mid: 1
            };
            await _NocoCache.default.set('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`, {
                messages: this.localJobs[jobId].messages
            });
        }
        if (this.jobRooms[jobId]) {
            this.jobRooms[jobId].listeners.forEach((res)=>{
                if (!res.headersSent) {
                    res.send(response);
                }
            });
        }
        if (_jobsredis.JobsRedis.available) {
            await _jobsredis.JobsRedis.publish(jobId, _extends({
                cmd: _Jobs.JobEvents.STATUS
            }, data));
        }
        if ([
            _Jobs.JobStatus.COMPLETED,
            _Jobs.JobStatus.FAILED
        ].includes(data.status)) {
            this.closedJobs.push(jobId);
            setTimeout(()=>{
                this.closedJobs = this.closedJobs.filter((j)=>j !== jobId);
            }, POLLING_INTERVAL * 2).unref();
            setTimeout(async ()=>{
                delete this.jobRooms[jobId];
                delete this.localJobs[jobId];
                await _NocoCache.default.del('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`);
            }, POLLING_INTERVAL * 2).unref();
        }
    }
    async sendJobLog(data) {
        let response;
        const jobId = data.id;
        if (this.localJobs[jobId]) {
            response = {
                status: 'update',
                data,
                _mid: ++this.localJobs[jobId]._mid
            };
            this.localJobs[jobId].messages.push(response);
            // limit to 20 messages
            if (this.localJobs[jobId].messages.length > 20) {
                this.localJobs[jobId].messages.shift();
            }
            await _NocoCache.default.set('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`, {
                messages: this.localJobs[jobId].messages
            });
        } else {
            response = {
                status: 'update',
                data,
                _mid: 1
            };
            this.localJobs[jobId] = {
                messages: [
                    response
                ],
                _mid: 1
            };
            await _NocoCache.default.set('root', `${_globals.CacheScope.JOBS_POLLING}:${jobId}:messages`, {
                messages: this.localJobs[jobId].messages
            });
        }
        if (this.jobRooms[jobId]) {
            this.jobRooms[jobId].listeners.forEach((res)=>{
                if (!res.headersSent) {
                    res.send(response);
                }
            });
        }
        if (_jobsredis.JobsRedis.available) {
            await _jobsredis.JobsRedis.publish(jobId, _extends({
                cmd: _Jobs.JobEvents.LOG
            }, data));
        }
    }
    constructor(jobsService){
        this.jobsService = jobsService;
        this.jobRooms = {};
        this.localJobs = {};
        this.closedJobs = [];
    }
};
_ts_decorate([
    (0, _common.Post)('/jobs/listen'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Res)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], JobsController.prototype, "listen", null);
_ts_decorate([
    (0, _eventemitter.OnEvent)(_Jobs.JobEvents.STATUS),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], JobsController.prototype, "sendJobStatus", null);
_ts_decorate([
    (0, _eventemitter.OnEvent)(_Jobs.JobEvents.LOG),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], JobsController.prototype, "sendJobLog", null);
JobsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], JobsController);
